@if (!item().hidden) {
  <!-- horizontal layouts -->
  @if (themeLayout === 'horizontal') {
    <li
      (mouseenter)="navCollapse($event)"
      class="nav-item pcoded-hasmenu"
      [routerLinkActive]="['active']"
      ngbTooltip="{{ !isEnabled ? 'You do not have permission to access this page ' : '' }}"
    >
      <a [routerLinkActive]="['active']" href="javascript:" class="nav-link" [ngClass]="{ disabled: !isEnabled }">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
      <ng-container *ngTemplateOutlet="subMenuContent"></ng-container>
    </li>
  }
  <!-- vertical layouts -->
  @if (themeLayout === 'vertical') {
    <li
      class="nav-item pcoded-hasmenu"
      [routerLinkActive]="['active']"
      ngbTooltip="{{ !isEnabled ? 'You do not have permission to access this page ' : '' }}"
    >
      <a
        [routerLinkActive]="['active']"
        href="javascript:"
        class="nav-link"
        (click)="navCollapse($event)"
        [ngClass]="{ disabled: !isEnabled }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
      <ng-container *ngTemplateOutlet="subMenuContent"></ng-container>
    </li>
  }
  <!-- all layout common -->
  <ng-template #itemContent>
    @if (item().icon) {
      <span class="pcoded-micon">
        <i class="{{ item().icon }}"></i>
      </span>
    }
    <span class="pcoded-mtext">
      {{ item().title | translate }}
      @if (item().badge && themeLayout === 'horizontal') {
        <span class="badge label" [ngClass]="item().badge.type">
          {{ item().badge.title | translate }}
        </span>
      }
    </span>
    @if (item().badge && themeLayout === 'vertical') {
      <span class="pcoded-badge badge" [ngClass]="item().badge.type">
        {{ item().badge.title | translate }}
      </span>
    }
  </ng-template>
  <ng-template #subMenuContent>
    <ul class="pcoded-submenu" [routerLinkActive]="['active']" [ngClass]="item().classes!">
      @for (items of item().children; track items) {
        @if (items.type === 'item') {
          <app-nav-item [item]="items" [parentRole]="item().role && item().role.length > 0 ? item().role : parentRole().role" />
        }
        @if (items.type === 'collapse') {
          <app-nav-collapse [item]="items" [parentRole]="item().role && item().role.length > 0 ? item().role : parentRole().role" />
        }
      }
    </ul>
  </ng-template>
}
